<div><h2>Our Mission:</h2>
<p>At {{ faq$ | async }}, our commitment to making an impact in today’s world is no less than our goal to providing extraordinary service
  to our policyholders.<br>
  {{ faq$ | async }} has partnered with {{ giveBackPartner$ | async }}, an industry leader in the Multi-family/ Single-family renters market. With over 130 years of insurance
  expertise, QBE delivers exceptional products and services to help Property Managers mitigate risk and lease apartments quickly.
  QBE is also committed to a culture of giving. Through QBE Premiums4Good, they allocate a portion of their global premium toward socially
  responsible, impact investments in the communities and environments they serve.
</p></div>

